module.exports = __webpack_public_path__ + "static/media/motion.3ed6fbf4.jpg";